
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'Features',
  components: {
    SpeedkitPicture,
  },
  props: {
    text: {
      type: String,
      require: false,
    },
    image: {
      type: Object,
      require: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },
}
